import { useEffect, useRef } from "react";
import { Switch, Route, useLocation } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { SessionProvider } from "@/context/SessionContext";
import Home from "@/pages/Home";
import Camps from "@/pages/Camps";
import CampDetail from "@/pages/CampDetail";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/not-found";

const GA_MEASUREMENT_ID = "G-3LK35KT7RL";

function ScrollToTop() {
  const [location] = useLocation();
  const prevPathRef = useRef<string>("");
  useEffect(() => {
    const path = location.split("?")[0];
    const prevPath = prevPathRef.current;
    prevPathRef.current = path;
    const isBackToList = path === "/camps" && /^\/camps\/[^/]+$/.test(prevPath);
    if (isBackToList) return;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);
  return null;
}

function GoogleAnalytics() {
  const [location] = useLocation();
  useEffect(() => {
    const gtag = (window as Window & { gtag?: (...args: unknown[]) => void }).gtag;
    if (gtag) {
      gtag("config", GA_MEASUREMENT_ID, { page_path: location });
    }
  }, [location]);
  return null;
}

function Router() {
  return (
    <>
      <ScrollToTop />
      <GoogleAnalytics />
      <Switch>
      <Route path="/" component={Home} />
      <Route path="/camps" component={Camps} />
      <Route path="/camps/:slug" component={CampDetail} />
      <Route path="/about" component={About} />
      <Route path="/how-it-works" component={HowItWorks} />
      <Route path="/contact" component={Contact} />
      <Route path="/terms" component={Terms} />
      <Route path="/privacy" component={Privacy} />
      <Route component={NotFound} />
    </Switch>
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <SessionProvider>
          <Toaster />
          <Router />
        </SessionProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
